import { render, staticRenderFns } from "./modal-yn.vue?vue&type=template&id=5bc346c6&"
import script from "./modal-yn.vue?vue&type=script&lang=js&"
export * from "./modal-yn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports